export default __webpack_public_path__ + "static/media/sample-background.424019b6.jpg";